import React, { useContext } from 'react';
import classnames from 'classnames';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';

var FieldWrapper = function FieldWrapper(props) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var wrapperProps = getCompProps('Form', userDefaultProps, props);
  var children = wrapperProps.children,
      customizePrefixCls = wrapperProps.prefixCls,
      width = wrapperProps.width,
      validateMessage = wrapperProps.validateMessage;
  var wrapperPrefixCls = getPrefixCls === null || getPrefixCls === void 0 ? void 0 : getPrefixCls(prefixCls, 'form-field-wrapper', customizePrefixCls);
  var wrapperClassName = classnames(["".concat(wrapperPrefixCls)]);
  var messageClassName = classnames(["".concat(wrapperPrefixCls, "-message")]);
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    style: {
      width: width
    }
  }, children, validateMessage && /*#__PURE__*/React.createElement("p", {
    className: messageClassName,
    title: validateMessage
  }, validateMessage));
};

export default FieldWrapper;